import Card from "../components/Card/Card";
import { Helmet } from "react-helmet";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
// import pics
import order from "../assets/images/2799166.png";
import repair from "../assets/images/1698478.png";
import sale from "../assets/images/3211590.png";

import { useEffect, useState } from "react";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import ComplatePriceModalAdmin from "common/order/ComplatePriceModalAdmin";
import Pagination from "rc-pagination";
import { ProductsOrder } from "common/order/ProductsOrder";
import { ProductsRepair } from "common/order/ProductsRepair";
import StatusReportModal from "common/order/StatusReportModal";

function AdminDashboard() {
  const [adminInfo, setAdminInfo] = useState({});
  const [orderLists, setOrderLists] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [chatList, setChatList] = useState([]);
  const updateSelectedItem = (information) => {
    setSelectedItem(information);
    setChatList(information.chats);
  };
  useEffect(() => {
    sendRequest("getordergeneralinfo").then(({ data }) => {
      setAdminInfo(data);
    });
  }, []);
  // state info from api

  useEffect(() => {
    sendRequest2("newfilterorder").then(({ data }) => {
      setOrderLists(data.info.reverse());
    });
  }, []);

  return (
    <div className="d-flex flex-wrap m-2">
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`داشبورد ادمین`} </title>
          <link rel="canonical" href="http://mysite.com/example" />
        </Helmet>
      </div>
      <>
        <UpdateRepairModal selectedItem={selectedItem}></UpdateRepairModal>
        <ComplatePriceModalAdmin selectedItem={selectedItem} />
        <UpdateOrderModal
          selectedItem={selectedItem}
          updateSelectedItem={updateSelectedItem}
        ></UpdateOrderModal>
        <StatusReportModal
          selectedItem={selectedItem}
          pageType="0"
          // chats={selectedItem.chats}
          // chats={chatList}
          // setChats={setChatList}
        ></StatusReportModal>

        <div className="col-lg-4 col-md-6 col-12">
          <Card
            title="تعداد سفارشات جاری"
            lightColor="#F2CC5B"
            darkColor="#B89B45"
            number={adminInfo.currentOrders}
            imgSrc={order}
            underline={true}
          ></Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card
            title="تعداد سفارش تعمیرات"
            lightColor="#503E9D"
            darkColor="#281F4F"
            number={adminInfo.repair}
            imgSrc={repair}
            underline={true}
          ></Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card
            title="تعداد فروش"
            lightColor="#56A689"
            darkColor="#3E7763"
            number={adminInfo.Sale}
            imgSrc={sale}
            underline={true}
          ></Card>
        </div>
      </>
      <div className="order-container">
        {orderLists
          .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
          .map((value, index) => {
            if (value.type == "0") {
              return (
                <ProductsOrder
                  data={value}
                  index={index}
                  updateSelectedItem={updateSelectedItem}
                  pageType="admin"
                ></ProductsOrder>
              );
            } else {
              return (
                <ProductsRepair
                  data2={value}
                  index={index}
                  updateSelectedItem={updateSelectedItem}
                  pageType="admin"
                ></ProductsRepair>
              );
            }
          })}
        <div className="d-flex justify-content-center mt-4">
          <div>
            <Pagination
              total={orderLists.length}
              pageSize={5}
              current={currentPage}
              onChange={(newPage) => {
                setCurrentPage(newPage);
              }}
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
